module.exports = "/img/user-guided-tours/customers-list/filters.png?2ce93bae448d1f46b2d59008f2f74546";